const SESSION_TIME = 60 * 60 * 1000;
const SESSION_KEY  = "userSession";

/**
 * setSession — always merges with existing session so partial updates
 * don't wipe unrelated keys (e.g. calling setSession({email}) won't
 * erase a previously stored projectId).
 *
 * All parameters are optional — only explicitly passed keys are updated.
 */
export const setSession = (updates = {}) => {
  // Read whatever is already in storage
  let existing = {};
  try {
    const raw = sessionStorage.getItem(SESSION_KEY);
    if (raw) existing = JSON.parse(raw);
  } catch { /* ignore parse errors */ }

  // Merge: existing values + new updates + refreshed expiry
  const merged = {
    ...existing,
    ...updates,                                      // spread — ALL keys in updates are stored
    expiry: new Date().getTime() + SESSION_TIME,     // always refresh expiry on any write
  };

  // Debug — remove in production
  console.log("[setSession] storing:", merged);

  sessionStorage.setItem(SESSION_KEY, JSON.stringify(merged));
};

/**
 * getSession — returns the stored session object, or null if missing/expired.
 */
export const getSession = () => {
  try {
    const raw = sessionStorage.getItem(SESSION_KEY);
    if (!raw) return null;

    const parsed = JSON.parse(raw);

    if (new Date().getTime() > parsed.expiry) {
      sessionStorage.removeItem(SESSION_KEY);
      return null;
    }

    return parsed;
  } catch {
    return null;
  }
};

/**
 * clearSession — wipes the entire session (logout).
 */
export const clearSession = () => {
  sessionStorage.removeItem(SESSION_KEY);
};